import ReactLogo from "../assets/icons/react.svg";
import JSLogo from "../assets/icons/javascript.png";
import HTMLLogo from "../assets/icons/html.png";
import mongodb from "../assets/icons/mongodb.png";
import nodejsLogo from "../assets/icons/nodejs.png";
import expressLogo from "../assets/icons/expressjs.png";
import reduxLogo from "../assets/icons/redux.png";
import gitLogo from "../assets/icons/git.png";
import CSSLogo from "../assets/icons/css.png";
import DSALogo from "../assets/icons/dsa.png";
import npmLogo from "../assets/icons/npm.svg";
import ChakraLogo from "../assets/icons/chakra.svg";
import TailwindCSS from "../assets/icons/tailwind_css.png";
import MaterialUI from "../assets/icons/material_ui.png";
import NestJs from "../assets/icons/nestjs.png";
import TypeScript from "../assets/icons/typescript.png";
import Postgresql from "../assets/icons/postgresql.png";
import Svelte from "../assets/icons/svelte.png";

export const skillData = [
  { name: "React", icon: ReactLogo },
  { name: "Redux", icon: reduxLogo },
  { name: "JavaScript", icon: JSLogo },
  { name: "TypeScript", icon: TypeScript },
  { name: "Svelte", icon: Svelte },
  { name: "NestJs", icon: NestJs },
  { name: "expressJS", icon: expressLogo },
  { name: "mongodb", icon: mongodb },
  { name: "PostgreSQL", icon: Postgresql },
  { name: "nodejs", icon: nodejsLogo },
  { name: "Chakra UI", icon: ChakraLogo },
  { name: "Tailwind CSS", icon: TailwindCSS },
  { name: "Material UI", icon: MaterialUI },
  { name: "HTML", icon: HTMLLogo },
  { name: "CSS", icon: CSSLogo },
  { name: "Git & Github", icon: gitLogo },
  { name: "npm", icon: npmLogo },
  { name: "DSA", icon: DSALogo },
];
